module.exports = __webpack_public_path__ + "static/media/cloud-upload.91fd1a1f.svg";